import styled, { css } from 'styled-components'
import {
  SPACING,
  BORDER_RADIUS,
  TRANSITIONS,
  TYPOGRAPHY,
  FONT_WEIGHT,
} from '../../../../styles/theme'

/**
 * CSS helpers — import into each question component to keep styles DRY.
 */

/** Applied to any element that can be "selected" (scale button, yes/no card, option card) */
export const selectedStyle = css`
  border-color: var(--color-primary);
  background: var(--color-primary-bg);
  color: var(--color-primary);
`

/** Applied to any focusable interactive element */
export const focusStyle = css`
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 2px var(--color-focus-ring);
`

/** Base interactive element — rest + hover state */
export const interactiveBase = css`
  border: 1px solid var(--color-border-dark);
  border-radius: ${BORDER_RADIUS.lg};
  cursor: pointer;
  transition: ${TRANSITIONS.fast};
  background: var(--color-bg-card);
  color: var(--color-text-primary);

  &:hover {
    border-color: var(--color-primary);
  }

  &:focus-visible {
    ${focusStyle}
  }
`

/**
 * Shared layout primitives used by all question components.
 */

export const QuestionLabel = styled.p`
  font-size: ${TYPOGRAPHY.body.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
  line-height: 1.5;
  margin: 0 0 ${SPACING.lg};
`

export const InputWrapper = styled.div`
  margin-top: 0;
  width: 100%;
`

export const HintText = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  color: var(--color-text-secondary);
`
